export const FORM_BORDER_WIDTH = 2;
export const FORM_HEADER_HEIGHT = 28;
export const FORM_FOOTER_HEIGHT = 21;
export const FORM_PADDING_LEFT = 6;
export const FORM_PADDING_RIGHT = 6;
export const PAGE_WIDTH = 325;
export const PAGE_HEIGHT = 96;
export const PAGE_ROW_GAP = 22;
export const PAGE_COLUMN_GAP = 22;
